import { useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';

import { fetchPasswordStatus } from './passwordStatus';

const OPEN = new Set(['/login', '/forgotPassword', '/resetPassword']);

export default function PasswordExpiryGate() {
  const [cookies, setCookie, removeCookie] = useCookies(['session', 'resetEmail']);
  const { pathname } = useLocation();
  const checkedSession = useRef('');

  useEffect(() => {
    if (!cookies.session || OPEN.has(pathname)) return undefined;
    if (checkedSession.current === cookies.session) return undefined;
    checkedSession.current = cookies.session;
    let cancelled = false;
    fetchPasswordStatus(cookies.session)
      .then((result) => {
        if (cancelled || result?.status !== 'success' || !result?.expired) return;
        const mail = String(result.mail || '').trim();
        removeCookie('session', { path: '/' });
        if (mail) {
          const expires = new Date(Date.now() + 15 * 60 * 1000);
          setCookie('resetEmail', mail, { path: '/', expires });
        }
        window.location.assign('/resetPassword');
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [cookies.session, pathname, removeCookie, setCookie]);

  return null;
}
